import { NgClass, NgFor, NgIf, NgOptimizedImage } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { RouterModule } from '@angular/router';
import { DynamicModule } from 'ng-dynamic-component';
import { StoryblokLinkDirective } from 'src/app/directive/storyblok-link.directive';
import { StoryblokRichTextDirective } from 'src/app/directive/storyblok-richtext.directive';
import { StoryblokDirective } from 'src/app/directive/storyblok.directive';
import { StoryBlokService } from 'src/app/service/storyblok.service';

@Component({
  selector: 'app-featured-articles',
  imports: [
    NgIf,

    NgFor,
    RouterModule,
    DynamicModule,
    StoryblokLinkDirective,
    StoryblokDirective,
    NgOptimizedImage,
    StoryblokRichTextDirective,
  ],
  templateUrl: './featured-articles.component.html',
  styleUrl: './featured-articles.component.scss',
})
export class FeaturedArticlesComponent implements OnInit {
  @Input() headline!: string;

  @Input() actions!: any[];
  @Input() eyebrow!: string;
  @Input() _editable: any;
  @Input() _uid!: string;
  @Input() component!: string;

  _articles: any = [];
  constructor(private storyblokService: StoryBlokService) {}

  ngOnInit() {
    this.storyblokService
      .getStories({
        content_type: 'article',
        sort_by: 'created_at:desc',

        starts_with: 'blogs/recipes',
        per_page: 1,
      })
      .then((data) => {
        this._articles = this._articles.concat(data.stories);
        for (let entry of this._articles) {
          entry.type = entry.full_slug.includes('article')
            ? 'Article'
            : 'Recipe';
        }
      });
    this.storyblokService
      .getStories({
        content_type: 'article',
        sort_by: 'created_at:desc',

        starts_with: 'blogs/articles',
        per_page: 1,
      })
      .then((data) => {
        this._articles = this._articles.concat(data.stories);
        for (let entry of this._articles) {
          entry.type = entry.full_slug.includes('article')
            ? 'Article'
            : 'Recipe';
        }
      });
  }
}
